// Floating pill that appears when new messages arrived while the user was
// scrolled up. Tap → snap to bottom and clear.

import { useTranslation } from '../i18n';
import { Icon } from './atoms/Icon';

export interface ScrollToBottomPillProps {
  count: number;
  onClick: () => void;
}

export function ScrollToBottomPill({ count, onClick }: ScrollToBottomPillProps) {
  const { t } = useTranslation();
  if (count <= 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="scroll-to-bottom"
      className="absolute left-1/2 -translate-x-1/2 bottom-4 z-10 px-3 py-1.5 rounded-full bg-action text-action-foreground text-caption font-medium shadow-lg hover:bg-action/90 focus:outline-none focus:ring-2 focus:ring-action inline-flex items-center gap-1.5"
      aria-label={t('scrollToBottom.label')}
    >
      <Icon name="ArrowDown" size={12} aria-hidden="true" />
      <span>
        {count === 1
          ? t('scrollToBottom.newMessage', { count })
          : t('scrollToBottom.newMessages', { count })}
      </span>
    </button>
  );
}

